import createReactComponent from '../createReactComponent';
export default createReactComponent('indifferent', 'Indifferent', [["path",{"d":"M9 15.5h6m-5.5-5V10m5 .5V10m6.5 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0","key":"svg-0"}]]);